import { Component, Input, TemplateRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic-modal',
  template: `
    <div class="modal-header">
      <h5 class="modal-title">{{ title | translate }}</h5>
      <button type="button" class="close" (click)="dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-container
        *ngIf="bodyTemplate"
        [ngTemplateOutlet]="bodyTemplate"
        [ngTemplateOutletContext]="bodyContext"
      ></ng-container>
    </div>
    <div class="modal-footer" *ngIf="showFooter">
      <button type="button" class="btn btn-sm btn-light" (click)="dismiss()">
        {{ cancelText | translate }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-success"
        *ngIf="confirmVisible"
        (click)="confirmFn()"
      >
        {{ confirmText | translate }}
      </button>
    </div>
  `,
})
export class GenericModalComponent {
  @Input() title: string = '';
  @Input() bodyTemplate!: TemplateRef<any>;
  @Input() bodyContext: any;
  @Input() showFooter: boolean = true;
  @Input() cancelText: string = 'navigations.close';
  @Input() confirmVisible: boolean = false;
  @Input() confirmText: string = 'navigations.save';

  constructor(public bsModalRef: BsModalRef) {}

  dismiss(): void {
    this.bsModalRef.hide();
  }

  confirmFn(): void {}
}
